import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1845691c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "healink" }

import { store } from "@/utils/store";

import MobileRegisterVue from "@/views/MobileRegister.vue";
import MobileSignIn from '@/views/MobileSignIn.vue';
import MobileSignUp from '@/views/MobileSignUp.vue';
import Header from '@/components/Header.vue';
import MobileUsers from '@/components/mobileHome/MobileUsers.vue';
import PersonalisCare from '@/components/mobileHome/PersonalisCare.vue';
import MobileDetail from "@/components/mobileHome/MobileDetail.vue";
import MobileLifestyle from '@/components/mobileHome/MobileLifestyle.vue';
import MobileStory from '@/components/mobileHome/MobileStory .vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileHome',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(store).mobileLogin && !_unref(store).mobileSignUp && !_unref(store).mobileRegister)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Header),
          _createVNode(PersonalisCare),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(MobileDetail)
          ]),
          _createVNode(MobileLifestyle),
          _createVNode(MobileUsers),
          _createVNode(MobileStory)
        ]))
      : _createCommentVNode("", true),
    (_unref(store).mobileSignUp)
      ? (_openBlock(), _createBlock(MobileSignUp, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(store).mobileLogin)
      ? (_openBlock(), _createBlock(MobileSignIn, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(store).mobileRegister)
      ? (_openBlock(), _createBlock(MobileRegisterVue, { key: 3 }))
      : _createCommentVNode("", true)
  ]))
}
}

})